import Vue from 'vue';
import App from './App.vue';
import router from './router';
// import store from './store'
import i18n from './lang';
import plugins from './plugins' // plugins
// import translate from 'i18n-jsautotranslate'
// translate.setUseVersion2() //设置使用v2.x 版本
// translate.selectLanguageTag.show = false //是否显示切换栏
// translate.listener.start() //监控页面动态渲染的文本进行自动翻译
// Vue.prototype.$translate = translate
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import infiniteScroll from 'vue-infinite-scroll'


Vue.use(infiniteScroll)
Vue.use(ElementUI);
Vue.use(plugins)
Vue.config.productionTip = false;
new Vue({
  i18n,
  router,
  // store,
  render: h => h(App)
}).$mount('#app');